import { useSelector, useDispatch } from "react-redux";
import FeatureHeaderButton from "@components/feature-header/feature-header-button";
import TableRow from "@components/view-all-table/table-row";
import TableHeader from "@components/view-all-table/table-header";
import { camelToTitle } from "@utils/string-helpers";

const CustomFeatureComponent = (props) => {
  const { onChange, value, name, id } = props;
  const dispatch = useDispatch();
  const schema = useSelector((state) => state.schema.clientSchema);
  const features = useSelector(
    (state) => state.schemaAllView.schemaManagementConfig.features
  );
  let isActive = value;

  const schemaLoadedFeatures = Object.keys(schema).length
    ? Object.keys(schema.properties.features.properties).map((featureItem) => ({
        name: featureItem,
        value: schema.properties.features.properties[featureItem].default,
      }))
    : [];

  const featuresLoaded = Object.keys(features ? features : {});
  const featureData = {
    name: name,
    value: value,
  };

  const onColumnHeaderClick = (columnLabel) => {
    let { sortReverse, sortBy } = this.state;
    let { tableConfig } = this.props;
    this.setState(
      {
        ...this.state,
        sortBy: columnLabel,
        formerSortProperty: columnLabel,
        sortReverse:
          columnLabel === sortBy
            ? !sortReverse
            : !!tableConfig.initialSortReverse,
      },
      () => this.sortData()
    );
  };

  let featuresTableConfig = {
    columns: [
      {
        name: "Status",
        width: "w-[21%]",
        componentType: "constructed-div",
        constructDiv: (feature) => {
          let isActive = feature.value;
          return (
            <div
              className="bottom-right-div"
              style={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "1rem",
              }}
            >
              <FeatureHeaderButton
                customButtonStyle="w-min-32"
                btnId="edit-feature-status"
                dataTestId={feature.name}
                show
                type="button"
                enabled
                theme={isActive ? "primary" : "secondary"}
                buttonText={isActive ? "ACTIVE" : "INACTIVE"}
                clickCallback={() => {
                  onChange(!value);
                }}
              />
            </div>
          );
        },
      },
      {
        name: "Feature",
        width: "w-[79%]",
        sortKey: "name",
        componentType: "string",
        emphasis: true,
        formatter: camelToTitle,
        dataKeys: {
          textContent: "name",
        },
      },
    ],
    voidLink: true,
  };

  return (
    <div id="feature-all-container" style={{ padding: "0 0 1% 3%" }}>
      <div
        className="bottom-right-div"
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "1rem",
        }}
      >
        {featuresLoaded[0] === name ? (
          <TableHeader
            customStyle="!m-0 !flex"
            tableConfig={featuresTableConfig}
          />
        ) : null}
        <TableRow
          key={id}
          tableConfig={featuresTableConfig}
          tableRowObj={featureData}
          customStyling={{
            rowBottom: { marginBottom: -12 },
            rowBody: { boxShadow: "none", marginLeft: 0, width: "68rem", height: "auto" },
          }}
        />
      </div>
    </div>
  );
};

export default CustomFeatureComponent;
